module.exports = __webpack_public_path__ + "static/media/left.a2a2b4ce.png";